import { Component, Input, Output, EventEmitter } from '@angular/core';

import { HhsgSharedHeaderMenuLink } from '../../menu/header-menu.component';
import { HhsgSharedNavHeader } from '../../../../models/nav-header.model';

@Component({
    selector: 'div[hhsg-nav-menu]',
    templateUrl: './nav-menu.component.html'
})
export class HhsgSharedNavMenuComponent {
    @Input() headers: HhsgSharedNavHeader[];
    @Input() applications: HhsgSharedHeaderMenuLink[];
    @Input() isMobile: boolean;

    // If a header link has been selected then this will be defined.
    // This is done this way because the MenuComponent is new everytime
    // The menu is opened.
    @Input() selectedHeader: HhsgSharedNavHeader;

    @Output() closeMenu = new EventEmitter<void>();
    @Output() headerLinkClicked = new EventEmitter<HhsgSharedNavHeader>();
    @Output() navLinkClicked = new EventEmitter();

    constructor() {       
    }

    isMobileApp(): boolean {
        return this.isMobile;
    }

    // When a header link is clicked then return to the parent which header link it was.
    onHeaderClick(header: HhsgSharedNavHeader) {   
        this.headerLinkClicked.emit(header);        
    }
}
